<template>
    <div :class="{'warning-icon':(!isMyUserAdmin)}" />
    <div>
      <DxTabs
        :data-source="screenList"
        :animation-enabled="true" 
        :swipe-enabled="false"
        v-model:selected-index="selectedScreen"
        styling-mode="secondary">
      </DxTabs>
    </div>   
    <div class="row justify-content-end">
      <div class="col-6 dx-field" style="text-align: right;margin: 1em 0 1em 0">
        <div class="dx-field-label"  style="font-size: 16px">Applied Tariff Profile</div>
        <div class="dx-field-value">
          <DxSelectBox
            ref="tariffProfileSelector"
            :value="tariffProfile.id"
            :data-source="tariffProfileList"
            valueExpr="id"
            displayExpr="label"
            styling-mode="underlined"
            :on-value-changed="setTariff"
          />
        </div>
        <div class="p-1" style="display: inline-block;width: 120px;">
          <DxButton style="border-radius:10%" styling-mode="outlined" icon='edit' :onClick='()=>{isTariffListVisible=true}'/>
          <DxButton style="border-radius:10%" styling-mode="outlined" icon='add' :onClick='()=>{isTariffCreationVisible=true}'/>
          <DxButton style="border-radius:10%" styling-mode="outlined" icon='remove' :onClick='()=>{isTariffRemoveVisible=true}'/>
        </div>
        
      </div>

    </div>
    
    <!------------------------- SCHEDULER ------------------------------------>

    <div id="scheduler-frame"> 
        <DxLoadPanel
          :position="loadingPosition"
          v-model:visible="loadingVisible"
          :show-indicator="true"
          :show-pane="true"
          :shading="true"
          :hide-on-outside-click="false"
          shading-color="rgba(244, 245, 245,0)"
        />
      <div style="" v-if="selectedScreen==0" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}" >
        <!--<h3 class="tab-subtitle"> Calendar</h3>-->
        <DxScheduler
          ref="scheduler"
          time-zone='ETC/GMT'
          :data-source="calendarArr"
          :current-date="currentDateView"
          :views="['week']"
          :height="770"
          :end-day-hour="24"
          :start-day-hour="0"
          :cellDuration="60"
          :first-day-of-week="1"
          current-view="week"
          :editing="false"
          @option-changed ="calendarChanged"
        >  <!--  :time-zone="timezone" -->
        <DxResource
          :data-source="advContractsData.touRates"
          field-expr="touRate"
        />
          
        </DxScheduler>

        
      </div>
        


     
      <div style="" v-show="selectedScreen==1" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}" class="touclass">
          <h3 class="tab-subtitle">Tariff Profile</h3>
          <DxForm :form-data="tariffProfile" :col-count="3" >
            
            <DxSimpleItem data-field="currency"  editor-type="dxSelectBox" :editor-options="{dataSource:currenciesList, displayExpr:'name',valueExpr:'id'}" />    
            <DxSimpleItem data-field="rateCode"  />
            <DxSimpleItem template="template"/>

            <DxSimpleItem :col-span="2" data-field="description"  />
          
            <DxButtonItem
              :button-options="{text: 'Save',
              type: 'success',
              onClick: saveTariffProfile, 
              width:'200'}"
              horizontal-alignment="center"
              vertical-alignment="center"
            />
        
            <template #template>
              <div class="mt-4">Provided by the Pricing service provider per its internal business.</div>
            </template>
          </DxForm>

          <h3 class="mt-4">Rate Components</h3>
          
          <DxDataGrid
            ref="rateComponentsTable"
            :data-source="rateComponentDS"
            :column-auto-width="true"
            :show-column-lines="true"
            @edit-canceled="editCancelRC"
            @saving="saveTableRC"
            :repaint-changes-only="true"
            > <!-- :on-saving="resetLookup"-->
            <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
              mode="batch"/>
            <DxColumn data-field="priority" width="10%" alignment="right"/>
            <DxColumn data-field="tariffDatePolicy_id" cell-template="cellTemplate_dates" caption="Date Group" width="15%" alignment="right">
              <DxLookup :data-source="advContractsData.datePolicies" value-expr="id" display-expr="description" />
            </DxColumn>
            <template #cellTemplate_dates="{ data }">
              {{ get_date_name(data) }}
            </template>
            <DxColumn data-field="timeIntervalsList" :allow-editing="false" alignment="right" cell-template="cellTemplate" />

            <DxColumn type="buttons" caption="Actions">
              <DxDGButton 
                icon="plus"
                hint="Add a Consumption rate"
                :on-click="addFnc"
              />
              <DxDGButton name="delete" />  
              <DxDGButton name="edit" />  
            </DxColumn>

            <template #cellTemplate="{ data }">
              <div style="margin: -11px">
              <DxDataGrid
                :data-source="data.value"
                :show-column-lines="true" 
                :show-column-headers="(data.rowIndex==0)"
                @row-updated="rangebarGraphUpdate();"
                :toolbar="{disabled:true, visible:false}"
                @saved="saveSubTableRC(data)"
                >
                <DxEditing
                  :allow-updating="true"
                  :allow-deleting="true"
                  mode="cell" 
                  :show-column-lines="true"/>

                <DxColumn data-field="start" caption="Start Hour"  alignment="right" data-type="datetime" format="HH:mm" :editor-options="{type:'time',displayFormat:'HH:mm'}"/>
                <!--<DxColumn data-field="duration"/>-->
                <DxColumn data-field="end" caption="End Hour"  alignment="right" data-type="datetime" format="HH:mm" :editor-options="{type:'time',displayFormat:'HH:mm'}">
                  <DxDGCustomRule :validation-callback="isValidHourTimeIntervals" message="Starting hour must me older than Ending hour"/>
                </DxColumn>
                <DxColumn data-field="touRate_id" cell-template="cellTemplate_tous" caption="TOU Rate" min-width="100px" alignment="right">
                  <DxLookup :data-source="advContractsData.touRates" value-expr="id" display-expr="description" />
                </DxColumn> 
                  <template #cellTemplate_tous="{ data }">
                  {{ get_tou_name(data) }}
                </template>
              </DxDataGrid>
              </div>
            </template>
            
          </DxDataGrid>

          <div style="margin-top: 3em">
            <h3 class="tab-subtitle"  style="margin-bottom: 1.5em">Tariff Summary Chart</h3> 
            <DxChart v-model:data-source="rangebarGraphArr2" ref="chartRef" height="300px" :rotated="true" :bar-group-padding="0.2">
              <DxArgumentAxis :tick="{ visible: false }" />
              <DxValueAxis
                :visual-range="[(new Date(+remoteTimeOffset-localTimeOffset-changeHourLocal).setHours(0,0,0,0)), 
                              new Date(+remoteTimeOffset-localTimeOffset-changeHourLocal).setHours(23, 59, 59, 999)]"
                :tick-interval="1000*60*60"
                :label="{customizeText:customizeHours}"/>
              <DxCommonSeriesSettings
                argument-field="dateGroup"
                type="rangebar"
                range-value1-field="startHour"
                range-value2-field="endHour"
                bar-overlap-group="dateGroup"
              />
              <!--<DxTooltip :customize-tooltip="timeLineTooltipFormatter" location="center" :enabled="true" />-->
              <DxSeriesTemplate name-field="touRate"/>
              <DxLegend vertical-alignment="bottom" horizontal-alignment="center" >
                <DxTitle text="Price Groups"/>
              </DxLegend>
            </DxChart>
          </div>

          <div style="margin-top: 3em">
            <div class="row">
              <div class="col"><h3 class="tab-subtitle"  style="margin-bottom: 1.5em">Electricity prices  for {{ new Date().toDateString() }}</h3> </div>
              <div class="col-2 d-flex justify-content-end align-items-center"><DxButton text="Refresh" icon="refresh" @click="reloadTariffPrices"/></div>
            </div>
            <DxChart :size="{height: 300}" :data-source="priceData" ref='graphV2'>
              <DxCommonSeriesSettings argument-field="time" type="stackedbar" :point="{visible:false}" />
              <DxSeries value-field="fixed_price" name="Fixed Price           "/>
              <DxSeries value-field="pool_price" name="Pool Price"/>
              <DxSeries value-field="total_price" name="Total Price" type="stepline" />
              <!--<DxSeries value-field="power_price" name="Power Price [€/MW]" type="stepline"  axis="power"/>-->      
              <DxArgumentAxis
                :visual-range="[new Date().setHours(0,0,0,0), 
                                new Date().setHours(23, 59, 59, 999)]"
                :tick-interval="1000*60*60"
                :label="{customizeText:customizeHours}"/>
              <DxValueAxis
                placeholder-size="7"
                :tick="{ visible: false }"
                :label="{customizeText:( value ) => {return `${value.value}€/MWh`}}" 
                :visual-range="{endValue:200}"/>
              <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
              <DxTooltip location="center" :customize-tooltip="customizeTooltip" :enabled="true" />
            </DxChart>

          </div>

        </div>
      
        <!------------------------- PARAMETERS ------------------------------------>
        <div style="" v-show="selectedScreen==2" :class="{'row':true , 'disabled-overlay':(!isMyUserAdmin)}" class="touclass">
          <h3 class="tab-subtitle ">Time of Use Rates</h3>
          <DxDataGrid
            ref="touRatesTable"
            :data-source="touRatesDS" 
            :column-auto-width="true"
            :show-column-lines="true"
            @saving="saveTableTR"
            @edit-canceled="editCancelTR"
            :repaint-changes-only="true">
              <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
              mode="batch" />

            <DxSelection mode="single" />
            <!--<DxColumn data-field="touTier"  caption="Tou Tier" min-width="100px" data-type="number"/>-->
            <DxColumn data-field="description" width="25%" alignment="right"><DxDGRequiredRule /></DxColumn>
            <DxColumn data-field="consumptionRatesList"  caption="Tou Tier" :allow-editing="false" alignment="right" cell-template="cellTemplate" />
            
            <DxColumn type="buttons" caption="Actions">
              <DxDGButton 
                icon="plus"
                hint="Add a Consumption rate"
                :on-click="addFnc_touRates"
              />
              <DxDGButton name="delete" />  
              <DxDGButton name="edit" />  
            </DxColumn>
            <template #cellTemplate="{ data }">
              <div style="margin: -11px"><!-- style="margin: -11px"-->
              <DxDataGrid
                  min-height="10px"
                  :data-source="data.value"
                  :show-column-lines="true" 
                  :show-column-headers="(data.rowIndex==0)"
                  @saved="saveSubTableTR(data)">
                  <DxEditing
                    :allow-updating="true"
                    :allow-deleting="true"
                    mode="cell" 
                    :show-column-lines="true"/>
                  <DxColumn data-field="term" > <!-- edit-cell-template="dropDownBoxEditor" -->
                     <DxLookup
                      :data-source="termList"
                      display-expr="label"
                      value-expr="label"
                    />
                  </DxColumn>
                  <DxColumn data-field="startValue"/>
                  <DxColumn data-field="price" cell-template="priceTemplate"/>
                  <template #priceTemplate ="{ data: cellInfo }">
                    <span style="text-align:right">{{ cellInfo.value }} {{ currenciesList.find(cur=> cur.id==tariffProfile.currency).symbol }} / {{ termList.find(tr=>tr.label==cellInfo.values[0])?.units }}</span>
                  </template>
                </DxDataGrid>
                </div>
            </template>
          </DxDataGrid>

          <div class="mt-3 mb-3">
             <DxButton 
              style="font-size:0.8rem"
              text="Edit the list of energy terms"
              styling-mode="text" 
              icon='edit' :onClick='()=>{isTermTableVisible=isTermTableVisible?false:true}'/>

            <div v-show="isTermTableVisible">
              <DxDataGrid 
                :data-source="termList"
                key-expr="id"
                :show-column-lines="true"
                @saving="saveTerms">
                 <DxEditing
                    :allow-updating="true"
                    :allow-deleting="true"
                    :allow-adding="true"
                    mode="batch" 
                    />
                <DxColumn data-field="name"><DxDGRequiredRule /></DxColumn>
                <DxColumn data-field="label"/>
                <DxColumn data-field="description"/>
                <DxColumn data-field="units">
                  <DxLookup
                    :data-source="['kW','kWh','kVArh','']"/>
                </DxColumn>
              </DxDataGrid>
            </div>
          </div>

          <h3 class="tab-subtitle">Date Groups</h3>
          <DxDataGrid
            ref="dateGroupTable"
            @editor-preparing="onDatePolEditorPrepare"
            :data-source="datePoliciesDS" 
            @saving="saveTableD"
            @edit-canceled="editCancelD"
            :show-column-lines="true"> <!-- @editor-preparing="onPreparing_dateGroups" -->
            <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
              mode="batch" /> 
            <DxSelection mode="single"/>

            <DxColumn data-field="description" min-width="150px"><DxDGRequiredRule /></DxColumn>
            <DxColumn data-field="type" min-width="140px" :set-cell-value="updateDatePolicyTypeVal">
              <DxDGRequiredRule />
              <DxLookup :data-source="tariffDatePolicyTypes" value-expr="id" display-expr="name"  />
            </DxColumn>
            <DxColumn caption="Days of Week" >    
              <DxColumn data-field="daysOfWeek0" caption="Mo" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek1" caption="Tu" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek2" caption="We" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek3" caption="Th" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek4" caption="Fr" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek5" caption="Sa" data-type="boolean" :value="false"></DxColumn>
              <DxColumn data-field="daysOfWeek6" caption="Su" data-type="boolean" :value="false"></DxColumn>
            </DxColumn>
            <DxColumn data-field="dateList" caption="Num. Dates" cell-template="cellTemplateList" :allow-editing="false"/>
            <template #cellTemplateList="{data}">
              {{ data.value?.length || 0 }}
            </template>
            <DxColumn type="buttons" caption="Actions">
              <DxDGButton 
                :visible="isAddDateIntervalVisible"
                icon="insertcolumnright"
                hint="Add-Edit a date/range"
                :on-click="openDateIntervalPopUp"
              />
              <DxDGButton name="delete" />
            </DxColumn>
          </DxDataGrid>

        </div>


    <!-- ----------------- -->

     <DxPopup
      content-template="delete-confirmation"
      :visible="isDeleteRcVisibled"
      :show-title="false"
      :hide-on-outside-click="false"
      :height="95"
      :width="280" >
      <template #delete-confirmation>
        <p> Are you sure you want to delete this item? </p>
        <div class="row mt-4">
          <div class="col"><DxButton text="YES" width="100%" styling-mode="text" type="danger" @click="deleteFnc()"/></div>
          <div class="col"><DxButton text="NO"  width="100%" styling-mode="text" type="danger" @click="()=>{isDeleteRcVisibled=false}"/></div>
        </div>
      </template> 
      
    </DxPopup>

    <DxPopup
      content-template="delete-confirmation"
      :visible="isDeleteRcVisibled_touRates"
      :show-title="false"
      :hide-on-outside-click="false"
      :height="95"
      :width="280" >
      <template #delete-confirmation>
        <p> Are you sure you want to delete this item? </p>
        <div class="row mt-4">
          <div class="col"><DxButton text="YES" width="100%" styling-mode="text" type="danger" @click="deleteFnc_touRates()"/></div>
          <div class="col"><DxButton text="NO"  width="100%" styling-mode="text" type="danger" @click="()=>{isDeleteRcVisibled_touRates=false}"/></div>
        </div>
      </template> 
      
    </DxPopup>

    <DxPopup
      :title="'Date list for: '+dateListPolicyObj.name"
      v-model:visible="isDateIntervalPopupOpen"
      :hide-on-outside-click="true"
      :height="600"
      :width="650" >
      <p>
        Use the following table to edit or add days or ranges to the date filter <em>{{dateListPolicyObj.name}} ({{dateListPolicyObj.id}}).</em><br><br>
        If you're using ranges the ending date is required to be equal to or greater than the starting date.
      </p>
      <DxDataGrid 
        ref="dayListTable"
        :data-source="dateListPolicyObj.dateList"
        @saved="saveSubTableD(dateListPolicyObj)"
        ><!--@saved="updateDatePolicyDList"-->
        <DxColumn data-field="description" data-type="text"><DxDGRequiredRule /></DxColumn>
        <DxColumn data-field="dateStart" data-type="date"><DxDGRequiredRule /></DxColumn>
        <DxColumn data-field="dateEnd" data-type="date">
          <DxDGCustomRule :validation-callback="isValidDatePolicyDates" message="Starting date must me older than Ending date"/>
        </DxColumn>
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          mode="cell" /> 
        <DxSelection mode="single"/>
      </DxDataGrid>
    </DxPopup>

    <DxPopup
      v-model:visible="isTariffListVisible"
      :hide-on-outside-click="true"
      :height="150"
      :width="450" 
      :show-close-button="true">
      <div style="font-size:14px;margin-bottom:1rem">Set the tariff name: </div>
      <div class="row">
        <div class="col-8">
          <DxTextBox
            styling-mode="underlined"
            v-model:value="tariffNewName"
            :input-attr="{ 'aria-label': 'Name' }">
            <DxValidator validation-group="setNameValidationGroup">
              <DxRequiredRule message="Name is required"/>
              <DxCustomRule
                :validation-callback="validateName"
                message="Existing tariff name."
              />
            </DxValidator>
          </DxTextBox>
        </div>
        <div class="col-4 p-1">
          <DxButton
            styling-mode="outlined"
            text="Save Name"
            icon="save"
            validation-group="setNameValidationGroup"
            :on-click="setTariffName"/>
        </div>
      </div>
    </DxPopup>


    <DxPopup
      v-model:visible="isTariffCreationVisible"
      :hide-on-outside-click="true"
      :height="150"
      :width="450" 
      :show-close-button="true">
      <div style="font-size:14px;margin-bottom:1rem">Set the tariff name: </div>
      <div class="row">
        <div class="col-8">
          <DxTextBox
            styling-mode="underlined"
            v-model:value="tariffNewName"
            :input-attr="{ 'aria-label': 'Name' }">
             <DxValidator validation-group="creationValidationGroup">
              <DxRequiredRule message="Name is required"/>
              <DxCustomRule
                :validation-callback="validateNewName"
                message="Existing tariff name."
              />
            </DxValidator>
          </DxTextBox>
        </div>
        <div class="col-4 p-1">
          <DxButton
            styling-mode="outlined"
            text="Save Name"
            icon="save"
            validation-group="creationValidationGroup"
            :on-click="createNewTariff"/>
        </div>
      </div>
    </DxPopup>


    <DxPopup
      :visible="isTariffRemoveVisible"
      :show-title="false"
      :hide-on-outside-click="false"
      :height="95"
      :width="285" >
        <p> Are you sure you want to delete this tariff? </p>
        <div class="row mt-2">
          <div class="col"><DxButton text="YES" width="100%" styling-mode="text" type="danger" @click="removeTariff()"/></div>
          <div class="col"><DxButton text="NO"  width="100%" styling-mode="text" type="danger" @click="()=>{isTariffRemoveVisible=false}"/></div>
        </div>
    </DxPopup>
    

  </div>

</template>
<script>
import DxTabs from "devextreme-vue/tabs";
import DxSelectBox from "devextreme-vue/select-box";
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import {DxValidator,
  DxRequiredRule,
  DxCustomRule,} from 'devextreme-vue/validator';
import { 
  DxDataGrid,
  DxEditing,
  DxColumn,
  DxSelection,
  DxLookup,
  //DxRowDragging,
  //DxSorting,
  DxButton as DxDGButton,
  DxRequiredRule as DxDGRequiredRule,
  DxCustomRule as DxDGCustomRule,
} from 'devextreme-vue/data-grid';
import {
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxValueAxis,
  DxSeriesTemplate,
  DxLegend,
  DxTitle,
  DxSeries,
  DxTooltip
} from 'devextreme-vue/chart';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScheduler, 
DxResource 
} from 'devextreme-vue/scheduler';
import { generateColors, currentPalette } from 'devextreme/viz/palette';
import { ref, reactive, onMounted } from 'vue';

import DataSource from "devextreme/data/data_source";
import RawDataService from '../services/RawDataServiceTemplate';
import { useStore } from 'vuex';
import { isEqual } from 'lodash';

import DxForm, {
  DxSimpleItem,
  DxButtonItem,
  //DxEmptyItem,
} from 'devextreme-vue/form';

export default {
  components: {
    DxSelectBox,
    DxForm, 
    DxSimpleItem,
    DxButtonItem,
    //DxEmptyItem,
    DxTextBox,
    DxDataGrid,
    DxColumn,
    DxLookup,
    //DxRowDragging,
    //DxSorting,
    DxEditing,
    DxSelection,
    DxDGButton,
    DxDGRequiredRule,
    DxDGCustomRule,
    DxPopup,
    DxLoadPanel,

    DxValidator,
    DxRequiredRule,
    DxCustomRule,
    DxChart,
    DxCommonSeriesSettings,
    DxArgumentAxis,
    DxSeriesTemplate,
    DxLegend,
    DxTitle,
    DxSeries,
    DxTooltip,
    DxValueAxis,
    DxScheduler,
    DxResource,
    DxTabs,
    DxButton,
  },
  data(){
    return {
      loadingPosition: { of: '#scheduler-frame' }
    }
  },
  setup () {

    

    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)
    //
    
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const loadingVisible = ref(true)
    const screenList = [
      { ctrId: 'CALENDAR', text:'CALENDAR' },
      { ctrId: 'TARIFF_PROFILE', text: 'TARIFF PROFILE'},
      { ctrId: 'GLOBAL', text: 'GLOBAL PARAMETERS' },
    ];
    const selectedScreen = ref(0);
    const timezone = ref(store.state.timezone);
    const remoteTimeOffset = ref(store.state.remoteTimeOffset*3600000);
    const localTimeOffset = ref(store.state.localTimeOffset*3600000);
    // cambio de hora 
    
    const changeHourLocal = ref(3600000*(store.state.localTimeOffset+new Date(0).getTimezoneOffset()/60))

    const toolbarRC_disabled = ref(false)

    const isTermTableVisible = ref(false)
    // Tariff profile -----------------
    let currenciesList = [{id:0, name:'Euro', symbol:'€'}, {id:1, name:'Dollar', symbol:'$'}];
    const tariffProfileDataService = new RawDataService('pricing/TariffProfiles', 'id')   
    const tariffProfileList = ref([])
    const tariffProfile = ref({id:null,label:''});

    const advContractsData = reactive({
      rateComponents:[],
      datePolicies:[],
      touRates:[],
    });

    let advContractsData_old = {}

    
    const saveTariffProfile= ()=>{
      try{
        tariffProfileDataService.update(tariffProfile.value.id,tariffProfile.value).then(res=>{
        if(res.isOk){
          notify('The Tariff profile has been updated','success',3000)
        }else{
          notify('Error updating  the Tariff Profile','error',3000)
        }
      })
      }catch(err){
        notify('Error: '+err,'error',3000)
      }
      
    }
    
  let rangebarGraphArr2 = ref([]);
  let chartRef = ref()
  const rateComponentStore = new CustomStore({
    key:'id',
    load:() =>{
      const rateComponentsList = advContractsData.rateComponents
      rangebarGraphUpdate()
      return rateComponentsList
    },
    update: (e,data)=>{
      try{
        const item_old = advContractsData.rateComponents.find(i=> i.id==e);
        Object.assign(item_old,data)

        //change
        /*const change_old = advContractsData_changes.rateComponents.find(i=> i.id==e);
        if(change_old) Object.assign(change_old,data)
        else advContractsData_changes.rateComponents.push({...item_old})*/
    
      }catch(error){ stErrorCb(error); }
    },
    insert: (data)=>{
      data.id=Math.max(...advContractsData.rateComponents.map(obj=>obj.id))+1;
      advContractsData.rateComponents.push(data)
      // change
      /*advContractsData_changes.rateComponents.push(data)*/
    },
    remove: (id)=>{
      advContractsData.rateComponents = advContractsData.rateComponents.filter(i=>i.id!=id)
    }

  })
  const rateComponentDS = new DataSource({
    store: rateComponentStore,
    paginate: false
  });

 
  const rangebarGraphUpdate =()=>{
    rangebarGraphArr2.value=[]
    const rateComponentsList = advContractsData.rateComponents
    rateComponentsList.forEach(async rc=>{
      const timeIntervalsList = rc.timeIntervalsList || []
      //rangebarGraphArr2.value = rangebarGraphArr2.value.filter(rbv=>rbv.id!=rc.id);
      let datePolicy = advContractsData.datePolicies.find(el=>el.id==rc.tariffDatePolicy_id)
      for(var ti of timeIntervalsList){
        let touRate = advContractsData.touRates.find(tr=>tr.id == ti.touRate_id)
        if(touRate){
          rangebarGraphArr2.value.push({
            id: rc.id,
            dateGroup:datePolicy.description || '',
            startHour:ti.start,
            endHour:ti.end,
            touRate:touRate.description,
          })
        }
        
      }
    })
  }
  const addFnc= async(data)=>{
    if(Object.keys(data.row.data).length > 0){
      if(!data.row.data.timeIntervalsList) data.row.data.timeIntervalsList=[]
      data.row.data.timeIntervalsList.push({
        touRate_id:0, 
        rateComponent_id: data.row.data.id,
        duration:86400000,
        start:0,
        end:86400000})
    }
    rateComponentsTable.value.instance.refresh()
  }
  
  const isDeleteRcVisibled = ref(false)
  let selectedRow;
  const showDeleteConfirmation = (data)=>{
    isDeleteRcVisibled.value=true
    selectedRow = data.data.id
  }
  const deleteFnc=()=>{
    rateComponentStore.remove(selectedRow)
    //rateComponentDS.reload()
    isDeleteRcVisibled.value=false
  }
  

  // Global parameters: -----------------
  // Tou rates

  const touRatesStore = new CustomStore({
    key:'id',
    load: async() =>{
      return advContractsData.touRates;
    },
    byKey: async(e)=>{
      return advContractsData.touRates.find(i=> i.id==e)
    },
    update: async (e,data)=>{
      try{
        const item_old = advContractsData.touRates.find(i=> i.id==e);
        Object.assign(item_old,data)
      }catch(error){ stErrorCb(error); }
    },
    insert: async(data)=>{
      data.id=Math.max(...advContractsData.touRates.map(obj=>obj.id))+1;
      advContractsData.touRates.push(data)
    },
    remove: async (id)=>{
      advContractsData.touRates = advContractsData.touRates.filter(i=>i.id!=id)
    }
  })

  const touRatesDS = new DataSource({
    store: touRatesStore,
    paginate: false
  });

  const get_tou_name = (id)=>{
    return advContractsData.touRates.find(sig => sig.id==id.value)?.description || ''
  }

  const touRatesTable= ref()
  const addFnc_touRates=(data)=>{
     if(Object.keys(data.row.data).length > 0){
      if(!data.row.data.consumptionRatesList) data.row.data.consumptionRatesList=[]
      data.row.data.consumptionRatesList.push({
        term:'Power',
        startValue:0, 
        price:0})
    }
    touRatesTable.value.instance.refresh()
  }
  
  const isDeleteRcVisibled_touRates = ref(false)
  const showDeleteConfirmation_touRates = (data)=>{
    isDeleteRcVisibled_touRates.value=true
    selectedRow = data.data.id
  }
  const deleteFnc_touRates=()=>{
    touRatesStore.remove(selectedRow)
    //touRatesDS.reload()
    isDeleteRcVisibled_touRates.value=false
  }

  // Date groups 
  let tariffDatePolicyTypes = [{id:1, name:'Days of Week'}, {id:2, name:'List of Days'}]; //{id:0, name:'Static'}, 
 
  const datePoliciesStore = new CustomStore({
    key:'id',
    load: async() =>{
      return advContractsData.datePolicies;
    },
    byKey: async(e)=>{
      return advContractsData.datePolicies.find(i=> i.id==e)
    },
    update: async (e,data)=>{
      try{
        const item_old = advContractsData.datePolicies.find(i=> i.id==e);
        /* daysOfWeek = item_old.daysOfWeek
  
        for(var i=0;i<7;i++){
          if('daysOfWeek['+i+']' in data){
              daysOfWeek[i]=Number(data['daysOfWeek['+i+']'])
          }
        }
        data.daysOfWeek = daysOfWeek;*/
        Object.assign(item_old,data)
      }catch(error){ stErrorCb(error); }

    },
    insert: async(data)=>{
      let daysOfWeek  = [0,0,0,0,0,0,0,0]
      for(var i=0;i<7;i++){
        if('daysOfWeek['+i+']' in data){
            daysOfWeek[i] = Number(data['daysOfWeek['+i+']'])
        }
      }
      data.daysOfWeek = daysOfWeek
      data.id=Math.max(...advContractsData.datePolicies.map(obj=>obj.id))+1;
      advContractsData.datePolicies.push(data)
    },
    remove: async (id)=>{
      advContractsData.datePolicies = advContractsData.datePolicies.filter(i=>i.id!=id)
    }
  })

  const datePoliciesDS = new DataSource({
    store: datePoliciesStore,
    paginate: false
  });

  const get_date_name = (id)=>{
    return advContractsData.datePolicies.find(sig => sig.id==id.value)?.description || ''
  }


  const isAddDateIntervalVisible = (e) => {//enabled after saved, only for type 'ListOfDates'
    return (e.row.rowType=="data" && e.row.data.type==2 && !e.row.isEditing)
  }
  const onDatePolEditorPrepare = (e) => {  
    let rowData = e.row.data;
    const weekdayFields = ['daysOfWeek0', 'daysOfWeek1', 'daysOfWeek2', 'daysOfWeek3', 'daysOfWeek4', 'daysOfWeek5', 'daysOfWeek6']
    if (rowData.type ==1){
      e.editorOptions.disabled = false;
      e.editorOptions.visible = true;
    } 
    if (rowData.type ==2 &&  weekdayFields.includes(e.dataField)){
      e.editorOptions.disabled = true;
      e.editorOptions.visible = false;
    } 
  }
  const updateDatePolicyTypeVal= (newData, value) =>{
      newData.type = value;
      newData.daysOfWeek0=0
      newData.daysOfWeek1=0
      newData.daysOfWeek2=0
      newData.daysOfWeek3=0
      newData.daysOfWeek4=0
      newData.daysOfWeek5=0
      newData.daysOfWeek6=0
    }



  // sumary -------------------
  var currentDateView=new Date();
  currentDateView=new Date(currentDateView-currentDateView.getTimezoneOffset()*60000);
  //currentDateView = new Date(currentDateView.toLocaleString('en-US',{timeZone:timezone.value}))
  const calendarArr = ref([]);
  
  const loadResources= ()=>{
    let touRates = advContractsData.touRates
    let paletteName = currentPalette(); //alt: 'Harmony Light'
    let priceColors = generateColors(paletteName, touRates.length, { baseColorSet: 'simpleSet', paletteExtensionMode: 'blend' });
    for (const ix in touRates){
      touRates[ix].color = priceColors[ix];
    }
  }

  const scheduler = ref(null)
  const loadCalendarDate = ()=>{
    try{
      calendarArr.value=[]
      const weekdayFields = ['daysOfWeek0', 'daysOfWeek1', 'daysOfWeek2', 'daysOfWeek3', 'daysOfWeek4', 'daysOfWeek5', 'daysOfWeek6']
      let rateComponentList = advContractsData.rateComponents.sort((a, b) => a.priority - b.priority)
      let touRates = advContractsData.touRates
      for(var rc of rateComponentList){
        const timeIntervalsList = rc.timeIntervalsList || []
        let datePolicy = advContractsData.datePolicies.find(el=>el.id==rc.tariffDatePolicy_id)
        //datePolicy.daysOfWeek = datePolicy.daysOfWeekBCD.data[0].toString(2).padStart(8,'0').split('').map(Number)
        for(var ti of timeIntervalsList){
          let touRate = touRates.find(tr=>tr.id == ti.touRate_id) 
          ti.start=ti.start % 86400000 ;
          ti.end=ti.end % 86400000 ;
          if (touRate){
            for(var i=0;i<7;i++){
              const currDay = currentDateView.setHours(1+ changeHourLocal.value/3600000,0,0,0) //-currentDateView%(24*60*60*1000)/
              const dayOfWeek = new Date(currentDateView+50).getDay()-i-1;
              const dayOfWeekMS= dayOfWeek*86400000;
              let day = {
                id: rc.id,
                dateGroup:datePolicy.description,
                startDate:new Date(ti.start + currDay-dayOfWeekMS - changeHourLocal.value), //- remoteTimeOffset.value + localTimeOffset.value
                endDate:new Date(ti.end + currDay-dayOfWeekMS - changeHourLocal.value),
                touRate:ti.touRate_id,
                text:touRate?.description || ''
              }
              if(datePolicy.type==1 && datePolicy[weekdayFields[i]]){
                
                const dayFilt = checkOccupation(calendarArr.value,day)
                for(let day of dayFilt)
                  calendarArr.value.push(day)
              }
              if(datePolicy.type==2){
                const dateList = datePolicy.dateList || []
                for(let dt of dateList){
                  if(day.startDate.getTime()>=dt.dateStart && day.startDate.getTime()<dt.dateEnd+86400000){
                    const dayFilt = checkOccupation(calendarArr.value,day)
                    for(let day of dayFilt)
                      calendarArr.value.push(day)
                  }
                }
              }
            }
          }
        }
      }
    }catch(err){ 
      notify(err.message, "error", 3000);
    }
  }
  
  const checkOccupation=(timeArr,task)=>{
	const solapamiento=timeArr.find(time=>time.endDate>=task.startDate && task.endDate>=time.startDate)

    let newTask=[]
    if(solapamiento){
      if(task.startDate<solapamiento.startDate){
        const subTask=checkOccupation(timeArr,Object.assign({...task},{endDate:new Date(solapamiento.startDate.getTime()-1)}))
        subTask.forEach(st=>newTask.push(st))
      }
      if(task.endDate>solapamiento.endDate){
        const subTask=checkOccupation(timeArr,Object.assign({...task},{startDate:new Date(solapamiento.endDate.getTime()+1)}))
        subTask.forEach(st=>newTask.push(st))
      }
      
    }else{
      newTask.push(task)
    }
    return newTask
  }


  const customizeHours = ( value ) => {
      var date = new Date(value.value)
      return formatDate(date);
    };
    function formatDate(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes ;
      return strTime;
    }
    
    const customizePrices = ( value ) => {
      var label = `${value.value} ${currenciesList.find(cur=> cur.id==tariffProfile.value.currency)?.symbol }/MWh`
      return label;
    };
    const customizePrices_power = ( value ) => {
      var label = `${value.value} ${currenciesList.find(cur=> cur.id==tariffProfile.value.currency)?.symbol }/MW`
      return label;
    };

    function customizeTooltip(value){
      const time = value.argument
      const pool_price = priceData.value.find(el=> el.time==time && !!el.pool_price)?.pool_price 
      const fixed_price = priceData.value.find(el=> el.time==time && !!el.fixed_price)?.fixed_price 
      const total_price = priceData.value.find(el=> el.time==time && !!el.total_price)?.total_price
        return { text: `Pool price: ${pool_price.toFixed(3)} €/MWh \n
          Fixed price: ${fixed_price.toFixed(3)} €/MWh \n
          Total price: ${total_price.toFixed(3)} €/MWh \n` }
    }

   const calendarChanged = (e)=>{
      if (e.name === "currentDate") {
        currentDateView = e.value;
        loadCalendarDate()
      }
        
    }

  
    const isDateIntervalPopupOpen = ref(false);
    const dateListPolicyObj = reactive({});
    const openDateIntervalPopUp = (e) => { 
      if (e.row && e.row.rowType=="data"){
        dateListPolicyObj.id = e.row.data.id;
        dateListPolicyObj.name = e.row.data.description;
        dateListPolicyObj.daysCount = e.row.data.daysCount||0;
        if (!e.row.data.dateList) e.row.data.dateList = []
        dateListPolicyObj.dateList = e.row.data.dateList;
        dateListPolicyObj.rowIndex = e.row.rowIndex
        isDateIntervalPopupOpen.value = true;
      }else{
        console.log('Error: no dates can be edited for this element');
      }
    }

    const isValidDatePolicyDates = (e) => { return e.data.dateEnd? (new Date(e.data.dateStart) <= new Date(e.data.dateEnd)):true; }
    const isValidHourTimeIntervals = (e) => { return e.data.end? (new Date(e.data.start) <= new Date(e.data.end)):true; }


    const rateComponentsTable = ref()
    const resetLookup = ()=>{
      rateComponentsTable.value.instance.refresh()
    }
    
    // Load ---------------------

    const algorithmsDataService = new RawDataService(`algorithms/eod`);

    const priceData = new ref([])
    const reloadTariffPrices = async () =>{
        algorithmsDataService.getAll().then(res=>{
          priceData.value=[]
          if(res.data.currentPowerProfile.datetime_unix_ms){
           
            for(let i=0;i<res.data.pool_price.datetime_unix_ms.length;i++){
              priceData.value.push({
                  time: res.data.pool_price.datetime_unix_ms[i],
                  pool_price: res.data.pool_price.value[i],
                  fixed_price: res.data.fixed_price.value[i],
                  //power_price: res.data.power_price[i],
                  total_price: res.data.total_price.value[i] 
              })
            }

          }
        })
    }
    reloadTariffPrices()
    ///
    const load = async()=>{
      
      // tariffPorfile
      tariffProfileList.value = await tariffProfileDataService.getAll()
      if(tariffProfileList.value.length==0){
        await tariffProfileDataService.create({enabled:true,label:'Default'})
        tariffProfileList.value = await tariffProfileDataService.getAll()
      }
      tariffProfile.value=tariffProfileList.value.find(tp=>tp.enabled)
      if(!tariffProfile.value){
        await tariffProfileDataService.update(tariffProfileList.value[0].id,{enabled:true})
        tariffProfile.value = tariffProfileList.value[0]
      }
      tariffNewName.value=tariffProfile.value.label;


      // Rate Components
      await loadRC()
      // Tou Rates
      await loadTR()
      // Date Policies
      await loadD()
  
    
      await rateComponentDS.reload()
      await touRatesDS.reload()
      await datePoliciesDS.reload()

      advContractsData_old = JSON.parse(JSON.stringify(advContractsData)); // copy without proxies

      termList.value = await new RawDataService('/pricing/TariffTerms').getAll()

      reloadTariffPrices()
    }

    // Save Rate Component configuration
    const loadRC = async ()=>{
      const rateComponentList = await new RawDataService('pricing/TariffProfiles/'+tariffProfile.value.id+'/RateComponents', 'id').getAll()
      advContractsData.rateComponents=rateComponentList; 
      
      for(let rc of rateComponentList){
        const uri_ti = '/pricing/RateComponents/'+rc.id+'/TimeIntervals'
        const timeIntervalsList= await new RawDataService(uri_ti, 'id').getAll()
        for(var ti of timeIntervalsList){
          ti.start=(ti.start + remoteTimeOffset.value - localTimeOffset.value + changeHourLocal.value ) ;
          ti.duration=ti.duration % 86400000 ;
          ti.end=(ti.duration+ti.start) 
        }
         rc.timeIntervalsList = timeIntervalsList
      }
    }

    const saveSubTableRC = async(e)=>{
      rateComponentsTable.value.instance.cellValue(e.rowIndex,'timeIntervalsList',e.value)
    }
    const editCancelRC = async() =>{
      loadingVisible.value = true;
      await loadRC()
      rateComponentsTable.value.instance.refresh()
      loadingVisible.value = false;     
    }

    const saveTableRC = async(e)=>{
      loadingVisible.value = true;
      const uri_rc = 'pricing/TariffProfiles/'+tariffProfile.value.id+'/RateComponents'
      for(let change of e.changes){
        if(change.type=='update'){
          const {timeIntervalsList, ...RCChanges} = change.data
          if(Object.keys(RCChanges).length>0)
            await new RawDataService(uri_rc, 'id').update(change.key,RCChanges)
            .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
            .catch(error=>stErrorCb(error))

          if(timeIntervalsList && Object.keys(timeIntervalsList).length>0){
            const uri_ti = '/pricing/RateComponents/'+change.key+'/TimeIntervals'
            let tiList_old = advContractsData_old.rateComponents.find(el=>el.id==change.key).timeIntervalsList;
            for(let ti of timeIntervalsList){
              const ti_old = tiList_old.find(el=>el.id==ti.id)
              if(ti_old && !isEqual(ti, ti_old)){
                const ti_aux = Object.assign(ti,{start:ti.start - remoteTimeOffset.value + localTimeOffset.value - changeHourLocal.value,duration:ti.end-ti.start})
                await new RawDataService(uri_ti, 'id').update(ti.id ,ti_aux)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }else if(!ti_old){
                const ti_aux = Object.assign(ti,{start:ti.start - remoteTimeOffset.value + localTimeOffset.value - changeHourLocal.value,duration:ti.end-ti.start})
                await new RawDataService(uri_ti, 'id').create(ti_aux)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
            for(let ti of tiList_old){
              if(!timeIntervalsList.find(el=>el.id==ti.id)){
                await new RawDataService(uri_ti, 'id').remove(ti.id)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
          }
        }
        else if(change.type=='insert'){
     
          const res = await new RawDataService(uri_rc, 'id').create(change.data)
            .catch(error=>stErrorCb(error))

          if(res.affectedRows>0){
            if(change.data.timeIntervalsList){
              const uri_ti = '/pricing/RateComponents/'+res.insertId+'/TimeIntervals'
              for(let ti of change.data.timeIntervalsList){
                const ti_aux = Object.assign(ti,{start:ti.start - remoteTimeOffset.value + localTimeOffset.value - changeHourLocal.value,duration:ti.end-ti.start})
                await new RawDataService(uri_ti, 'id').create(ti_aux)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }else{
              notify('Date policy successfully created' ,'success',3000);
            }
          }
        }
        else if(change.type=='remove'){
          await new RawDataService(uri_rc, 'id').remove(change.key)
            .then(res=>{ if(res.isOk) notify('ToU Rate successfully removed' ,'success',3000);})
            .catch(error=>stErrorCb(error))
        }
      }

      // load
      await loadRC()
      await rateComponentDS.reload()
      advContractsData_old = JSON.parse(JSON.stringify(advContractsData)); 
      loadResources()
      loadCalendarDate()
      
      loadingVisible.value = false;
    }

    // Save ToU Rates configuration
    const loadTR = async()=>{
      const touRatesList = (await new RawDataService('pricing/TouRates', 'id').getAll()).filter(tr=>tr.id!=0)
      advContractsData.touRates = touRatesList
      for(let tr of advContractsData.touRates){
        const uri_tr = '/pricing/TouRates/'+tr.id+'/ConsumptionRates'
        tr.consumptionRatesList = await new RawDataService(uri_tr, 'id').getAll()
        tr.consumptionRatesList.forEach(cr=>{cr.price= cr.price.toFixed(5)})
      }
    }
    const saveSubTableTR = async(e)=>{
      touRatesTable.value.instance.cellValue(e.rowIndex,'consumptionRatesList',e.value)
    }
    const editCancelTR = async() =>{
      loadingVisible.value = true;
      await loadTR()
      await touRatesDS.reload()
      touRatesTable.value.instance.refresh()
      loadingVisible.value = false;     
    }

    const saveTableTR = async(e)=>{
      loadingVisible.value = true;
      for(let change of e.changes){
        if(change.type=='update'){
         
          const {consumptionRatesList, ...TRChanges} = change.data

          if(Object.keys(TRChanges).length>0)
            await new RawDataService('pricing/TouRates', 'id').update(change.key,TRChanges)
            .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
            .catch(error=>stErrorCb(error))

          if(consumptionRatesList && Object.keys(consumptionRatesList).length>0){
            const uri_ti = '/pricing/TouRates/'+change.key+'/ConsumptionRates'
            let ctList_old = advContractsData_old.touRates.find(el=>el.id==change.key).consumptionRatesList
            for(let ti of consumptionRatesList){
              const ti_old = ctList_old.find(el=>el.id==ti.id)
              if(ti_old && !isEqual(ti, ti_old)){
                console.log('ti update')
                await new RawDataService(uri_ti, 'id').update(ti.id,ti)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }else if(!ti_old){
                console.log('ti create')
                await new RawDataService(uri_ti, 'id').create(ti)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
            for(let ti of ctList_old){
              if(!consumptionRatesList.find(el=>el.id==ti.id)){
                console.log('ti remove')
                await new RawDataService(uri_ti, 'id').remove(ti.id)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
            
          }
        }
        else if(change.type=='insert'){
          const res = await new RawDataService('pricing/TouRates', 'id').create(change.data)
            .catch(error=>stErrorCb(error))
          if(res.affectedRows>0){
            if(change.data.consumptionRatesList){
              const uri_ti = '/pricing/TouRates/'+res.insertId+'/ConsumptionRates'
              for(let ti of change.data.consumptionRatesList){
                await new RawDataService(uri_ti, 'id').create(ti)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }else{
              notify('Date policy successfully created' ,'success',3000);
            }
          }
        }
        else if(change.type=='remove'){
          await new RawDataService('pricing/TouRates', 'id').remove(change.key)
            .then(res=>{ if(res.isOk) notify('ToU Rate successfully removed' ,'success',3000);})
            .catch(error=>stErrorCb(error))
        }
      }

      // load
      await loadTR()
      await touRatesDS.reload()
      advContractsData_old = JSON.parse(JSON.stringify(advContractsData)); 

      loadResources()
      loadCalendarDate()
      
      loadingVisible.value = false;
    }


    // Save terms  
    const saveTerms =async (e)=>{
      for(let change of e.changes){
        if(change.type=='update'){
          await new RawDataService('/pricing/TariffTerms').update(change.key,change.data)
          .then(res=>{ if(res.isOk) notify('Term successfully updated' ,'success',3000);})
          .catch(error=>stErrorCb(error))
        }else if(change.type=='insert'){
          await new RawDataService('/pricing/TariffTerms').create(change.data)
          .then(res=>{ if(res.isOk) notify('Term successfully created' ,'success',3000);})
          .catch(error=>stErrorCb(error))
        }else if(change.type=='remove'){
          await new RawDataService('/pricing/TariffTerms').remove(change.key)
          .then(res=>{ if(res.isOk) notify('Term successfully removed' ,'success',3000);})
          .catch(error=>stErrorCb(error))
        }
      }
      termList.value= await new RawDataService('/pricing/TariffTerms').getAll().catch(error=>stErrorCb(error))
    }
   
    // Save  Date Groups configuration
    const loadD = async()=>{
      const datePoliciesList = (await new RawDataService('pricing/DatePolicies', 'id').getAll()).filter(tr=>tr.id!=0)
      advContractsData.datePolicies = datePoliciesList;
      for(let dp of datePoliciesList){
        let daysOfWeek = dp.daysOfWeekBCD.data[0].toString(2).padStart(8,'0').split('').map(Number)
        dp.daysOfWeek0=daysOfWeek[0]
        dp.daysOfWeek1=daysOfWeek[1]
        dp.daysOfWeek2=daysOfWeek[2]
        dp.daysOfWeek3=daysOfWeek[3]
        dp.daysOfWeek4=daysOfWeek[4]
        dp.daysOfWeek5=daysOfWeek[5]
        dp.daysOfWeek6=daysOfWeek[6]

        dp.dateList = await new RawDataService('/pricing/DatePolicies/'+dp.id+'/DateList', 'id').getAll()
      }
    }
    const dateGroupTable = ref()
    const dayListTable = ref()
    const saveSubTableD = async(e)=>{
      dateGroupTable.value.instance.cellValue(e.rowIndex,'dateList',e.dateList)
    }
    const editCancelD = async() =>{
      loadingVisible.value = true;
      await loadD()
      await datePoliciesDS.reload()
      dateGroupTable.value.instance.refresh()
      dayListTable.value.instance.refresh()
      loadingVisible.value = false;     
    }
    const saveTableD = async(e)=>{
      loadingVisible.value = true;
      const weekdayFields = ['daysOfWeek0', 'daysOfWeek1', 'daysOfWeek2', 'daysOfWeek3', 'daysOfWeek4', 'daysOfWeek5', 'daysOfWeek6']
      for(let change of e.changes){
        if(change.type=='update'){
          const {dateList, ...DChanges} = change.data
          
          if(Object.keys(DChanges).length>0){
            
            let dp = advContractsData_old.datePolicies.find(el=>el.id==change.key) 
            let daysOfWeek = [dp.daysOfWeek0,dp.daysOfWeek1,dp.daysOfWeek2,dp.daysOfWeek3,dp.daysOfWeek4,dp.daysOfWeek5,dp.daysOfWeek6,0];
            for(let idx =0; idx<weekdayFields.length; idx++){
              if(typeof change.data[weekdayFields[idx]] !=='undefined'){
                
                daysOfWeek[idx]=change.data[weekdayFields[idx]]?1:0
              } 
            }
            
            DChanges.daysOfWeekBCD = parseInt(daysOfWeek.join(''),2)
            await new RawDataService('pricing/DatePolicies', 'id').update(change.key,DChanges)
             .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
              .catch(error=>stErrorCb(error))
          }

          if(dateList && Object.keys(dateList).length>0){
            const uri_ti = '/pricing/DatePolicies/'+ change.key +'/DateList'
            let dList_old = advContractsData_old.datePolicies.find(el=>el.id==change.key).dateList
            for(let ti of dateList){
              if (typeof ti.dateStart!='number')ti.dateStart = ti.dateStart.getTime()
              if (typeof ti.dateEnd!='number') ti.dateEnd = ti.dateEnd?.getTime() || ti.dateStart+60*60*24

              const ti_old = dList_old.find(el=>el.id==ti.id)
              if(ti_old && !isEqual(ti, ti_old)){
                console.log('ti update')
                await new RawDataService(uri_ti, 'id').update(ti.id,ti)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }else if(!ti_old){
                console.log('ti create')
                await new RawDataService(uri_ti, 'id').create(ti)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
            for(let ti of dList_old){
              if(!dateList.find(el=>el.id==ti.id)){
                console.log('ti remove')
                await new RawDataService(uri_ti, 'id').remove(ti.id)
                  .then(res=>{ if(res.isOk) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }
          }
        }
        else if(change.type=='insert'){
          let daysOfWeek = [0,0,0,0,0,0,0,0];
          for(let idx =0; idx<weekdayFields.length; idx++){
            if(typeof change.data[weekdayFields[idx]] !=='undefined'){
              daysOfWeek[idx]=change.data[weekdayFields[idx]]?1:0
            } 
          }
          change.data.daysOfWeekBCD = parseInt(daysOfWeek.join(''),2)
          const res = await new RawDataService('pricing/DatePolicies', 'id').create(change.data)
          .catch(error=>stErrorCb(error))
          
          if(res.affectedRows>0){
            if(change.data.dateList){
              const uri_ti = '/pricing/DatePolicies/'+ res.insertId +'/DateList'
              for(let ti of change.data.dateList){
                if (typeof ti.dateStart!='number')ti.dateStart = ti.dateStart.getTime()
                if (typeof ti.dateEnd!='number') ti.dateEnd = ti.dateEnd?.getTime() || ti.dateStart+60*60*24

                await new RawDataService(uri_ti, 'id').create(ti)
                  .then(res=>{ if(res.affectedRows>0) notify('Changes successfully updated' ,'success',3000);})
                  .catch(error=>stErrorCb(error))
              }
            }else{
              notify('Date policy successfully created' ,'success',3000);
            }
          }
        }
        else if(change.type=='remove'){
          await new RawDataService('pricing/DatePolicies', 'id').remove(change.key)
            .then(res=>{ if(res.isOk) notify('Date policy successfully removed' ,'success',3000);})
            .catch(error=>stErrorCb(error))
        }
      }

      // Load
      await loadD()
      await datePoliciesDS.reload()
      advContractsData_old = JSON.parse(JSON.stringify(advContractsData)); 
      loadResources()
      loadCalendarDate()
      
      loadingVisible.value = false;
    }

    // SELECTION TARIFF
    const setTariff = async (e)=>{
      if(!e.previousValue || !tariffProfileList.value.find(tr=>tr.id==e.previousValue)) return;
      await tariffProfileDataService.update(e.previousValue,{enabled:false})
      await tariffProfileDataService.update(e.value,{enabled:true})
      tariffProfile.value=tariffProfileList.value.find(tr=>tr.id==e.value)

      loadingVisible.value = true
      await load()
      loadResources()
      loadCalendarDate()
      loadingVisible.value = false;
    }
    const isTariffListVisible = ref(false)
    const tariffNewName = ref('')
    const tariffProfileSelector = ref()
    const setTariffName= async (e)=>{
      const res = e.validationGroup.validate()
      if(res.isValid==false) return;
      tariffProfileDataService.update(tariffProfile.value.id,{label:tariffNewName.value})
      tariffProfile.value.label = tariffNewName.value
      tariffProfileList.value.find(tp=>tp.id==tariffProfile.value.id).label=tariffNewName.value
      isTariffListVisible.value=false
      tariffProfileSelector.value.instance.repaint()
    }
    const termList =ref([])

    const isTariffCreationVisible = ref(false)
    const createNewTariff = async(e)=>{
      const res = e.validationGroup.validate()
      if(res.isValid==false) return;
      await tariffProfileDataService.create({label:tariffNewName.value,enabled:true}).catch(error=>stErrorCb(error))
      await tariffProfileDataService.update(tariffProfile.value.id,{enabled:false})
      isTariffCreationVisible.value=false;
      loadingVisible.value = true
      await load()
      loadResources()
      loadCalendarDate()
      loadingVisible.value = false;
    }
    
    const isTariffRemoveVisible = ref(false)
    const removeTariff = async()=>{
      if(tariffProfileList.value.length==1){
         isTariffRemoveVisible.value=false;
        notify('You need to have at least one tariff created.','warning',4000);
        return;
      }
      isTariffRemoveVisible.value=false;
      await tariffProfileDataService.update(tariffProfileList.value[0].id,{enabled:true})
      await tariffProfileDataService.remove(tariffProfile.value.id).then(res=>{
        if(res.isOk){
          notify('Tariff removed','success',3000)
        }
      }).catch(error=>stErrorCb(error))
      tariffProfileList.value = await tariffProfileDataService.getAll();
      
      
      
      
      loadingVisible.value = true
      await load()
      loadResources()
      loadCalendarDate()
      loadingVisible.value = false;
    }

    const validateName = (e) =>{ 
      const tariffListF=tariffProfileList.value.filter(t=>t.id!=tariffProfile.value.id)
      if(tariffListF.find(t=>t.label==e.value)) return false;
      else return true;
      
    }
    const validateNewName = (e) =>{ 
      if(tariffProfileList.value.find(t=>t.label==e.value)) return false;
      else return true;
      
    }

    onMounted(async ()=>{
        loadingVisible.value = true
        await load()
  
        loadResources()
        loadCalendarDate()
        
        loadingVisible.value = false;
    })

    return {
      isTariffListVisible,
      isTariffCreationVisible,
      isTariffRemoveVisible,
      isMyUserAdmin,
      resetLookup,
      rateComponentsTable,
      touRatesTable,
      currenciesList,
      tariffProfile,
      rateComponentDS,
      touRatesDS,
      datePoliciesDS,
      tariffProfileList,
      tariffDatePolicyTypes,
      chartRef,
      customizeHours,
      calendarChanged,
      currentDateView,
      saveTariffProfile,
      setTariff,
      setTariffName,
      tariffNewName,
      dateGroupTable,
      dayListTable,
      createNewTariff,
      removeTariff,
      tariffProfileSelector,
      
      isDateIntervalPopupOpen,
      openDateIntervalPopUp,
      dateListPolicyObj,
      isValidDatePolicyDates,
      isValidHourTimeIntervals,

      isAddDateIntervalVisible,
      onDatePolEditorPrepare,
      updateDatePolicyTypeVal,
      advContractsData,
      get_date_name,
      get_tou_name,
      rangebarGraphUpdate,
      loadCalendarDate,
      toolbarRC_disabled,
      saveTableRC,
      saveTerms,
      saveTableTR,
      saveSubTableTR,
      saveSubTableRC,
      saveSubTableD,
      saveTableD,
      editCancelTR,
      editCancelRC,
      editCancelD,
      screenList,
      selectedScreen,
      loadingVisible,
      scheduler,

      rangebarGraphArr2,
      calendarArr,
      addFnc_touRates,
      deleteFnc_touRates,
      showDeleteConfirmation_touRates,
      isDeleteRcVisibled_touRates,
      addFnc,
      deleteFnc,
      showDeleteConfirmation,
      isDeleteRcVisibled,
      termList,
      validateName,
      validateNewName,
      timezone,
      remoteTimeOffset,
      localTimeOffset, 
      changeHourLocal,
      isTermTableVisible,

      priceData,
      customizePrices,
      customizePrices_power,
      customizeTooltip,
      reloadTariffPrices
    }
  },
  
}
</script>
<style lang="scss">
  .tab-subtitle {
    padding-top: 1rem;
  }
  .myButton {
    margin:-6px /* Cambia 'blue' al color que desees */
  }

  .myButton .dx-button {
    border: none;
  }
 
  .touclass{
    .dx-datagrid-rowsview.dx-empty {
      height: 38px;
  }}

</style>
